import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Dashboard";

export default {
  getCompany: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetCompanyAssets`, payload);
  },
  getSites: (companyGuid: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSiteAssets`, {
      params: { companyGuid },
    });
  },
  getGroups: (siteGuid: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetGroupAssets`, {
      params: { siteGuid },
    });
  },
  getComputers: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetGroupAssetsWithComputer`, payload);
  },
};
